import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ConservationTypeCreateDto, ConservationTypeDto, ConservationTypeExcelDownloadDto, ConservationTypeUpdateDto, GetConservationTypesByCodesInputDto, GetConservationTypesInputDto } from '../dtos/conservation-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ConservationTypeService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: ConservationTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ConservationTypeDto>({
      method: 'POST',
      url: '/api/planning/conservationTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/conservationTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/conservationTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  findByCodes = (input: GetConservationTypesByCodesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ConservationTypeDto[]>({
      method: 'POST',
      url: '/api/planning/conservationTypes/by-codes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ConservationTypeDto>({
      method: 'GET',
      url: `/api/planning/conservationTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/conservationTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetConservationTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ConservationTypeDto>>({
      method: 'GET',
      url: '/api/planning/conservationTypes',
      params: { description: input.description, code: input.code, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: ConservationTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/conservationTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, description: input.description, code: input.code, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ConservationTypeDto[]>({
      method: 'GET',
      url: '/api/planning/conservationTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: ConservationTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ConservationTypeDto>({
      method: 'PUT',
      url: `/api/planning/conservationTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}